// extracted by mini-css-extract-plugin
export default {"SectionContainer":"SectionContainer_SectionContainer__rbt4D"};